import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { forgotPassword } from '../lib/api';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Shield, MailCheck } from 'lucide-react';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await forgotPassword(email);
    } catch { /* same message either way */ }
    setSent(true);
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-8 bg-[#09090B]">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 mb-8">
          <Shield className="w-8 h-8 text-[#C0A062]" />
          <span className="text-xl font-bold text-white">
            DOJO<span className="text-[#C0A062]">DASH</span>
          </span>
        </Link>

        {sent ? (
          <div className="bg-[#18181B] border border-zinc-800 rounded-lg p-6" data-testid="forgot-sent-message">
            <MailCheck className="w-8 h-8 text-[#C0A062] mb-4" />
            <h1 className="text-2xl font-bold text-white mb-2">Check your inbox</h1>
            <p className="text-zinc-400">
              If that address is registered, a link is on its way.
            </p>
            <Link to="/login" className="inline-block mt-6 text-sm text-[#C0A062] hover:underline" data-testid="forgot-back-to-login">
              ← Back to login
            </Link>
          </div>
        ) : (
          <>
            <h1 className="text-3xl font-bold text-white mb-2">Forgot your password?</h1>
            <p className="text-zinc-400 mb-8">Enter your email and we&apos;ll send you a reset link.</p>

            <form onSubmit={handleSubmit} className="space-y-6" data-testid="forgot-password-form">
              <div>
                <Label htmlFor="email" className="text-zinc-300">Your email address</Label>
                <Input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="mt-2 bg-[#18181B] border-zinc-800 text-white"
                  placeholder="you@example.com"
                  required
                  data-testid="forgot-email-input"
                />
              </div>
              <Button type="submit" disabled={loading} className="w-full btn-primary py-6" data-testid="forgot-submit-btn">
                {loading ? <span className="spinner w-5 h-5" /> : 'Send reset link'}
              </Button>
            </form>

            <p className="mt-8 text-center">
              <Link to="/login" className="text-sm text-zinc-400 hover:text-zinc-200" data-testid="forgot-back-to-login">
                ← Back to login
              </Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
